import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { showToast } from "../guest-slices/other.slice"
import { BASEURI, headers } from "../../utils/helper"
import { Cookies } from "react-cookie"
import axios from "axios"
import { asyncThunkWrapper } from "../thunkHandler"

const cookies = new Cookies()

// Handle get updated details
export const getUpdatedDetailsReq = createAsyncThunk("getUpdatedDetailsReq", async (_, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.get(`${BASEURI}/specialist/auth/get-updated-details`, {
      headers: headers()
    })
    if (response.data?.success) {
      return response.data?.data
    }

    return response
  } catch (error) {
    if (error.response.data.redirect) {
      dispatch({ type: "Logout" })
    }
    return rejectWithValue(error)
  }
})

// Handle specialist registration
export const specialistRegistrationReq = createAsyncThunk("specialistRegistrationReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/specialist/auth/register`, data)

    if (response.data?.success) {
      if (response.data.token) {
        cookies.set("token", response.data.token, { path: "/" })
      }
      dispatch(showToast({
        type: "success",
        message: response.data?.message
      }))
      return response.data?.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(showToast({ type: "error", message: newErr }))
    return rejectWithValue(error)
  }
})

// Handle create expertise
export const createExpertiseReq = createAsyncThunk("specialistRegistrationReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/specialist/auth/create/experties`, data, {
      headers: {
        ...headers(),
        "Content-Type": "multipart/form-data"
      }
    })

    if (response.data?.success) {
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(showToast({ type: "error", message: newErr }))
    return rejectWithValue(error)
  }
})

// Handle create background
export const createBackgroundReq = createAsyncThunk("specialistRegistrationReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/specialist/auth/create/background`, data, {
      headers: {
        ...headers(),
        "Content-Type": "multipart/form-data"
      }
    })

    if (response.data?.success) {
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(showToast({ type: "error", message: newErr }))
    return rejectWithValue(error)
  }
})

// Handle create profile
export const createProfileReq = createAsyncThunk("specialistRegistrationReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/specialist/auth/create/professional-profile`, data, {
      headers: {
        ...headers(),
        "Content-Type": "multipart/form-data"
      }
    })

    if (response.data?.success) {
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(showToast({ type: "error", message: newErr }))
    return rejectWithValue(error)
  }
})

// --------------- Set availability ---------------
export const handleSetAvailability = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/specialist/auth/set/availability`,
      },
      thunkAPI
    )
  }
)

// --------------- Get availability ---------------
export const handleGetAvailability = createAsyncThunk(
  "retrieveSingle",
  async (_, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/auth/get/availability`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

const initialState = {
  specialist: {},
  other: {}
}

const auth = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    // Handle get updated details
    builder.addCase(getUpdatedDetailsReq?.fulfilled, (state, { payload }) => {
      state.specialist = payload
    })
    builder.addCase(specialistRegistrationReq?.pending, (state) => {
      state.specialist.loadingSignup = true
    })
    builder.addCase(specialistRegistrationReq?.fulfilled, (state) => {
      delete state?.specialist?.loadingSignup
    })
    builder.addCase(specialistRegistrationReq?.rejected, (state) => {
      delete state?.specialist?.loadingSignup
    })

    // Logout
    builder.addCase("Logout", () => initialState)
  }
})

export default auth.reducer